//External libs
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import Service from '../common/service';
//Local libs

/**
 * Service for managing Subscribers data.
 *
 * Provides methods to fetch, process, and manage subscriber statistics.
 *
 * @module BluEyeStatsService
 */
@Injectable({
  providedIn: 'root'
})
export class BluEyeStatsService extends Service<any> {

  /**
   * @param {Subscription[]} ongoingRequests - An array to store ongoing HTTP request subscriptions.
   */
  public ongoingRequests: Subscription[] = [];

  /**
   * Constructs an instance of BluEyeStatsService.
   * 
   * @param {HttpClient} httpClient - The HttpClient service for making HTTP requests.
   * @param {Router} router - The Router service for navigation.
   */
  constructor(httpClient: HttpClient, router: Router) {
    super(httpClient, '/tradingcommunity/blueyedaystats/');
  }

  /**
   * @method
   * @param {any} fromDate - Start date for fetching statistics.
   * @param {any} toDate - End date for fetching statistics.
   * @returns {Promise<Array<any>>} A Promise that resolves with an array of subscriber stats.
   * @throws {string} If there is an error during the HTTP request, an error message will be thrown.
   * Description:
   * Retrieves all subscriber statistics between the provided fromDate and toDate.
   * Typically called in {@link SubscriptionsComponent}.
   */
  public getBlueyedayStats(fromDate: any, toDate: any): Promise<Array<any>> {
    return new Promise<Array<any>>((resolve, reject) => {
      const request = this.httpClient.get<Array<any>>(
        `${this.baseUrl}${this.serviceUrl}?page=0&pageSize=1000&fromDate=${fromDate}&toDate=${toDate}`, 
        this.httpOptions
      ).subscribe(response => {
        resolve(response);
      }, (error: HttpErrorResponse) => {
        reject(error);
      });
      this.ongoingRequests.push(request);
    });
  }

  /**
   * @method
   * @returns {void} This function does not return a value.
   * Description: 
   * Cancels any ongoing HTTP requests by unsubscribing from their observables, 
   * ensuring proper cleanup and preventing memory leaks.
   * Typically called in {@link SubscriptionsComponent}.
   */
  public cancelOnGoingHttpRequests(): void {
    this.ongoingRequests.forEach((request) => {
      if (request && typeof request.unsubscribe === 'function') {
        request.unsubscribe();
      }
    });
    this.ongoingRequests = [];
  }
}
